import { CircularProgress, Fade, fade, Grid, makeStyles, Typography } from '@material-ui/core';
import { grey } from '@material-ui/core/colors';
import React from 'react';


const LoadingContainer = ({loading, children}) => {

    const classes = useStyles()

    return ( 
        <div>
            {loading ? (
                <Fade in>
                    <div className={classes.root}>
                        <div className={classes.container}>
                            <div className={classes.loader}>
                                <Grid container direction='column' spacing={1} alignItems='center'>
                                    <Grid item><CircularProgress size={40} /></Grid>
                                    <Grid item>
                                        <Typography style={{color:grey[700]}}>Loading...</Typography>
                                    </Grid>
                                </Grid>
                            </div>
                        </div>
                    </div>
                </Fade>
            ) : children}
        </div>
        
     );
}

const useStyles = makeStyles(theme => ({
    root:{
        width:'100%',
        height:'100%',
        position:'absolute',
        top:0, left:0,
        background: fade("#FFF", 0.70),
        zIndex:5,
        fontFamily:theme.typography.fontFamily
    },
    container:{
        position:'relative',
        width:'100%',
        height:'100%',
    },
    loader:{
        position:'absolute',
        left:'50%',
        top:"50%",
        transform:'translate(-50%, -50%)'
    }
}))
 
export default LoadingContainer;